module.exports = __webpack_public_path__ + "img/product-icon.e8c81a2e.png";